import { ChangeDetectorRef, Component } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { RouterOutlet } from '@angular/router'

import { RouteLoggerService } from 'common/util/services/routeLogger.service'
import { SpinnerIconComponent } from 'common/util/components/spinnerIcon.component'
import { AppSidebarService } from 'main/services/appSidebar.service'
import { AppNavbarComponent } from 'main/components/appNavbar.component'
import { AppSidebarComponent } from 'main/components/appSidebar.component'
import { UploaderService } from 'uploader/services/uploader.service'
import { UploaderPanelComponent } from 'uploader/components/uploaderPanel.component'

export const routeChangingTrigger = trigger('routeChanging', [
  state(
    'true',
    style({
      'transform': 'translateX(-50px)',
      'opacity': 0,
      'pointer-events': 'none',
    }),
  ),
  state(
    'false',
    style({
      'transform': 'translateX(0)',
      'opacity': 1,
      'pointer-events': 'initial',
    }),
  ),
  transition('false => true', [
    animate('125ms ease-out'),
  ]),
  transition('true => false', [
    style({ transform: 'translateX(50px)', opacity: 0 }),
    animate('125ms ease-out'),
  ]),
])

@Component({
  selector: 'app-root',
  templateUrl: './appRoot.component.html',
  styleUrls: ['./appRoot.component.scss'],
  animations: [routeChangingTrigger],
  imports: [
    AppNavbarComponent,
    AppSidebarComponent,
    RouterOutlet,
    SpinnerIconComponent,
    UploaderPanelComponent,
  ],
})
export class AppRootComponent {
  protected isRouteChanging = false

  constructor (
    public uploader: UploaderService,
    public appSidebar: AppSidebarService,
    public routeLogger: RouteLoggerService,
    private cdr: ChangeDetectorRef,
  ) {
    document.addEventListener('click', () => {
      if (document.activeElement?.tagName === 'BUTTON') {
        document.activeElement['blur']?.()
      }
    })

    // This used to be bound directly to [@routeChanging] as
    // `routeLogger.routeChanging$ | async`, but due to what seems like
    // an Angular bug, change detection triggered by `AsyncPipe` alone
    // is not enough to kick off the animation.
    routeLogger.routeChanging$.pipe(takeUntilDestroyed()).subscribe(isChanging => {
      this.isRouteChanging = isChanging
      this.cdr.markForCheck()
      this.cdr.detectChanges()
    })
  }

  collapseSidebar () {
    if (!this.appSidebar.collapsed && window['mobileMode']) {
      this.appSidebar.toggle()
    }
  }

  get prefersReducedMotion () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }
}
